export const Timer = (callback: () => void, delay: number) => {
    var timerId: number,
        start: Date,
        remaining = delay;

    const pause = () => {
        window.clearTimeout(timerId);
        remaining -= new Date().getMilliseconds() - start.getMilliseconds();
    };

    const resume = () => {
        start = new Date();
        window.clearTimeout(timerId);
        timerId = window.setTimeout(callback, remaining);
    };

    resume();

    return {
        pause,
        resume,
    };
};

export type TimerType = {
    pause: () => void;
    resume: () => void;
};
